const UsersService = {

  parseUserPicture: function(response) {
    if (!response) return null;

    return {
      id: response.id,
      templateHref: response.template_href,
      originalHref: response.original_href
    }
  },

  parseUser: function(response) {
    if (!response) return null;

    return {
      id: response.id,
      displayName: response.display_name,
      userPicture: UsersService.parseUserPicture(response._embedded['dm:user_picture:v1']),
      _links: response._links,
      _forms: response._forms
    };
  }

};

export default UsersService;


// WEBPACK FOOTER //
// ./src/api/services/usersService.js